/*jshint esversion: 6 */
import React, { Component } from 'react';
import Footer from "../../footer";
import {Typography, Row, Col, Input, Button} from "antd";
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import './contact.css';
import Texts from "../../../utils/Text";
import emailjs from 'emailjs-com';
import { MailOutlined, PhoneOutlined, HomeOutlined } from '@ant-design/icons';


const { Text } = Typography;

export default class Contacts extends Component {
    state = {
        color: 'white',
        isMobile: window.screen.width < 769,
        isModalOpen: false,
        name: '',
        companyName: '',
        email: '',
        phone: '',
        text: '',
        subject: '',
    };

    sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('info_vrglobal', 'template_6cfpvbb', e.target, 'akBLkicmXyfhZwvhI')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        this.setState({
            name: '',
            companyName: '',
            phone: '',
            email: ''
        });
        e.target.reset();
    };
    render() {
      const mapData = {
          center: [43.239120, 76.948295],
          zoom: 17,
      };
      const {name, companyName,phone, email, isMobile} = this.state;
      return (
        <>
            <div className="montserrat contact-content">
                <Row justify="center" style={{ fontSize: "36px", paddingTop: '100px', marginBottom: '10px'}}>
                        <Text>{Texts('contacts', 'title')}</Text>
                    </Row>
                <Row justify="center" style={{marginTop: '16px', paddingBottom: '60px'}}>
                    <div style={{width:'100%', height: isMobile? '100%' :'568px', border: '1px solid black', position: 'relative'}}>
                        <YMaps>
                            <Map
                                defaultState={mapData}
                                width="100%"
                                height={`${isMobile ? '400px': '100%'}`}
                            >
                                <Placemark
                                    geometry={[43.239784, 76.948277]}
                                    options={{
                                        iconColor: 'red',
                                    }}/>
                            </Map>
                        </YMaps>
                        {!isMobile && <div className="info">
                            <Row justify="center" style={{marginBottom: 15}}>
                                <Col span={12} style={{textAlign: 'center'}}>
                                    <Text className={"white-text"} style={{fontSize: 20}}><b>Наши контакты</b></Text>
                                </Col>
                                <Col span={12} style={{textAlign: 'center'}}>
                                    <Text className={"white-text"} style={{fontSize: 20}}><b>Свяжитесь с нами</b></Text>
                                </Col>
                            </Row>
                            <Row justify="center" >
                                <Col span={12}>
                                    <Row className="white-text">
                                        <HomeOutlined style={{marginRight: 6, paddingTop: 3}}/>
                                        <Text className={"white-text"}>Адрес:</Text>
                                    </Row>
                                    <Row style={{marginBottom: 15}}>
                                        <Text className={"white-text"}>{Texts('contacts', 'address')}</Text>
                                    </Row>
                                    <Row className="white-text">
                                        <MailOutlined style={{marginRight: 6, paddingTop: 3}}/>
                                        <Text className={"white-text"}>Email:</Text>
                                    </Row>
                                    <Row style={{marginBottom: 15}}>
                                        <Text className={"white-text"}>{Texts('contacts', 'email')}</Text>
                                    </Row>
                                    <Row className="white-text">
                                        <PhoneOutlined style={{marginRight: 6, paddingTop: 3}}/>
                                        <Text className={"white-text"}>Телефон:</Text>
                                    </Row>
                                    <Row style={{marginBottom: 15}}>
                                        <Text className={"white-text"}>{Texts('contacts', 'phone')}</Text>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <form onSubmit={this.sendEmail}>
                                        <div style={{textAlign: 'center'}}>
                                            <div style={{marginBottom: '10px'}}>
                                                <Input type='text' placeholder="Имя*" name="name" value={name} onChange={(e)=>{this.setState({name: e.target.value})}}/>
                                            </div>
                                            <div style={{marginBottom: '10px'}}>
                                                <Input type='text' placeholder="Телефон*" name="phone" value={phone} onChange={(e)=>{this.setState({phone: e.target.value})}}/>
                                            </div>
                                            <div style={{marginBottom: '10px'}}>
                                                <Input type='text' placeholder="Email*" name="email" value={email} onChange={(e)=>{this.setState({email: e.target.value})}}/>
                                            </div>
                                            <div style={{marginBottom: '10px'}}>
                                                <Input type='text' placeholder="Название компании" name="companyName" value={companyName} onChange={(e)=>{this.setState({companyName: e.target.value})}}/>
                                            </div>
                                            <div style={{marginBottom: '10px'}}>
                                                <Button
                                                    style={{width: '100%'}}
                                                    type="primary"
                                                    htmlType="submit"
                                                    disabled={!name || !phone || !email}
                                                >
                                                    Отправить
                                                </Button>
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </div>}
                    </div>
                    {isMobile && <div className="info">
                        <Row justify="center" style={{marginBottom: 15}}>
                            <Col span={12} style={{textAlign: 'center'}}>
                                <Text className={"white-text"} style={{fontSize: 20}}><b>Наши контакты</b></Text>
                            </Col>
                            <Col span={12} style={{textAlign: 'center'}}>
                                <Text className={"white-text"} style={{fontSize: 20}}><b>Свяжитесь с нами</b></Text>
                            </Col>
                        </Row>
                        <Row justify="center" >
                            <Col span={12}>
                                <Row className="white-text">
                                    <HomeOutlined style={{marginRight: 6, paddingTop: 3}}/>
                                    <Text className={"white-text"}>Адрес:</Text>
                                </Row>
                                <Row style={{marginBottom: 15}}>
                                    <Text className={"white-text"}>{Texts('contacts', 'address')}</Text>
                                </Row>
                                <Row className="white-text">
                                    <MailOutlined style={{marginRight: 6, paddingTop: 3}}/>
                                    <Text className={"white-text"}>Email:</Text>
                                </Row>
                                <Row style={{marginBottom: 15}}>
                                    <Text className={"white-text"}>{Texts('contacts', 'email')}</Text>
                                </Row>
                                <Row className="white-text">
                                    <PhoneOutlined style={{marginRight: 6, paddingTop: 3}}/>
                                    <Text className={"white-text"}>Телефон:</Text>
                                </Row>
                                <Row style={{marginBottom: 15}}>
                                    <Text className={"white-text"}>{Texts('contacts', 'phone')}</Text>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <form onSubmit={this.sendEmail}>
                                    <div style={{textAlign: 'center'}}>
                                        <div style={{marginBottom: '10px'}}>
                                            <Input type='text' placeholder="Имя*" name="name" value={name} onChange={(e)=>{this.setState({name: e.target.value})}}/>
                                        </div>
                                        <div style={{marginBottom: '10px'}}>
                                            <Input type='text' placeholder="Телефон*" name="phone" value={phone} onChange={(e)=>{this.setState({phone: e.target.value})}}/>
                                        </div>
                                        <div style={{marginBottom: '10px'}}>
                                            <Input type='text' placeholder="Email*" name="email" value={email} onChange={(e)=>{this.setState({email: e.target.value})}}/>
                                        </div>
                                        <div style={{marginBottom: '10px'}}>
                                            <Input type='text' placeholder="Название компании" name="companyName" value={companyName} onChange={(e)=>{this.setState({companyName: e.target.value})}}/>
                                        </div>
                                        <div style={{marginBottom: '10px'}}>
                                            <Button
                                                style={{width: '100%'}}
                                                type="primary"
                                                htmlType="submit"
                                                disabled={!name || !phone || !email}
                                            >
                                                Отправить
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </Col>
                        </Row>
                    </div>}
                </Row>
            </div>
            <Footer/>
        </>
      );
  }
}

